"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Field = void 0;
class Field {
}
exports.Field = Field;



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/casa-rules-v2/field.js
// module id = 1223
// module chunks = 0